export default {
      id: "reports_parkings-usage",
      viewBox: "0 0 39 44",
      url: __webpack_public_path__ + "img/icons.svg#reports_parkings",
      toString: function () {
        return this.url;
      }
    }